// extracted by mini-css-extract-plugin
export var askAiIcon = "_mp-j";
export var category = "_mp-9";
export var categoryHeader = "_mp-e";
export var container = "_mp-0";
export var group = "_mp-a";
export var groupItems = "_mp-f";
export var groupSeparator = "_mp-k";
export var loading = "_mp-1";
export var noResults = "_mp-3";
export var placeholder = "_mp-2";
export var resultContent = "_mp-5";
export var resultIcon = "_mp-c";
export var resultItem = "_mp-g";
export var resultMeta = "_mp-8";
export var resultSubtitle = "_mp-7";
export var resultSuffix = "_mp-i";
export var resultTitle = "_mp-6";
export var resultsList = "_mp-4";
export var searchGroup = "_mp-d";
export var selected = "_mp-h";
export var subgroup = "_mp-b";